<template>
  <!--
    	作者：fzf
    	时间：2025-12-03
    	描述：学习数据
    -->
  <div class="product">

    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="课程ID">
          <el-input size="small" v-model="searchForm.material_id" placeholder="课程ID"></el-input>
        </el-form-item>

        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>

           <!-- <el-date-picker
              size="small"
              v-model="searchForm.create_time"
              type="date"
              format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker> -->


             <el-date-picker
                  v-model="searchForm.create_time"
                  type="datetimerange"
                  :picker-options="pickerOptions"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  align="right">
                </el-date-picker>
          </div>
        </el-form-item>


        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onExport">导出学习数据</el-button>
        </el-form-item>
      </el-form>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        loading: true,
        searchForm:{
          'material_id':'',
          'create_time':'',
        },

         pickerOptions: {
            shortcuts: [{
              text: '最近一周',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit('pick', [start, end]);
              }
            }]
          },



      };
    },
    created() {
    },
    methods: {

      /*导出 10361*/
      onExport() {
        let self = this;
        let baseUrl = window.location.protocol + '//' + window.location.host;
        let data = self.searchForm;
        let date_s = data.create_time[0]?self.formatDateToYmdHms(data.create_time[0]):'';
        let date_e = data.create_time[1]?self.formatDateToYmdHms(data.create_time[1]):'';
        let eurl = baseUrl + '/index.php/api/tool/estudy?skey=k5Bguv0zEkcsTO1N&material_id='+data.material_id+'&&date_s='+date_s+'&&date_e='+date_e;
        console.log(eurl);
        window.open(eurl);
      },

      /**
       * 将日期字符串/Date对象格式化为 YYYY-MM-DD HH:mm:ss 格式
       * @param {string|Date} date - 输入的日期字符串（如 Wed Dec 03 2025 17:08:55 GMT+0800）或 Date 对象
       * @returns {string} 格式化后的日期字符串
       */
      formatDateToYmdHms(date) {
        // 1. 处理输入：如果是字符串，先转为 Date 对象；如果是 Date 对象直接使用
        const targetDate = typeof date === 'string' ? new Date(date) : date;

        // 2. 验证日期有效性（避免无效日期导致的 NaN）
        if (isNaN(targetDate.getTime())) {
          console.error('无效的日期格式');
          return '';
        }

        // 3. 提取年、月、日、时、分、秒（注意：月份是 0-11，需加 1）
        const year = targetDate.getFullYear(); // 年份（4位，如 2025）
        const month = targetDate.getMonth() + 1; // 月份（0-11 → 1-12）
        const day = targetDate.getDate(); // 日期（1-31）
        const hours = targetDate.getHours(); // 小时（0-23）
        const minutes = targetDate.getMinutes(); // 分钟（0-59）
        const seconds = targetDate.getSeconds(); // 秒（0-59）

        // 4. 补零函数：不足两位的数字前面补 0（如 3 → 03，9 → 09）
        const padZero = (num) => num.toString().padStart(2, '0');

        // 5. 拼接成目标格式
        return `${year}-${padZero(month)}-${padZero(day)} ${padZero(hours)}:${padZero(minutes)}:${padZero(seconds)}`;
      }

    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/material2/idata.vue